var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "selection" },
    [
      _c(
        "el-form",
        {
          staticClass: "demo-form-inline",
          attrs: {
            "label-position": "left",
            inline: true,
            model: _vm.selectionForm
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "锐锢编码" } },
            [
              _c("el-input", {
                attrs: { placeholder: "锐锢编码" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoods.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.selectionForm.ruigu_code,
                  callback: function($$v) {
                    _vm.$set(_vm.selectionForm, "ruigu_code", $$v)
                  },
                  expression: "selectionForm.ruigu_code"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品名称" } },
            [
              _c("el-input", {
                attrs: { placeholder: "商品名称" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoods.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.selectionForm.name,
                  callback: function($$v) {
                    _vm.$set(_vm.selectionForm, "name", $$v)
                  },
                  expression: "selectionForm.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "分类" } },
            [
              _c("el-input", {
                attrs: { placeholder: "分类" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoods.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.selectionForm.c_name,
                  callback: function($$v) {
                    _vm.$set(_vm.selectionForm, "c_name", $$v)
                  },
                  expression: "selectionForm.c_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "品牌" } },
            [
              _c("el-input", {
                attrs: { placeholder: "品牌" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchGoods.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.selectionForm.brand_name,
                  callback: function($$v) {
                    _vm.$set(_vm.selectionForm, "brand_name", $$v)
                  },
                  expression: "selectionForm.brand_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.searchGoods }
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.exportGoods }
                },
                [_vm._v("导出")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.selectGoods }
                },
                [_vm._v("选品")]
              ),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  staticClass: "export-btn-drop",
                  attrs: {
                    accept: _vm.fileTypeStr,
                    action: "",
                    "before-upload": _vm.beforeUpload,
                    "http-request": _vm.httpRequest,
                    "show-file-list": false
                  }
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("导入取消选品")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleDown }
                },
                [_vm._v("下载导入模板")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("classify-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadingSelection,
            expression: "loadingSelection"
          }
        ],
        ref: "classifyTable",
        attrs: { TableData: _vm.TableData, type: _vm.type }
      }),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [10, 50, 100, 200],
          "page-size": _vm.pagesize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.totalCount
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0537cad2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0537cad2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/basic/selection.vue
// module id = null
// module chunks = 